export default [
  {
    path: "/professional",
    component: () =>
      import(
        /* webpackChunkName: "professional" */ "@/views/Professional/pages"
      ),
    children: [
      {
        path: "/",
        name: "Professional",
        component: () =>
          import(
            /* webpackChunkName: "professional" */ "@/views/Professional/pages/Professional"
          ),
      },
      {
        path: "list-specialties",
        name: "ListSpecialties",
        component: () =>
          import(
            /* webpackChunkName: "professional" */ "@/views/Professional/pages/ListSpecialties"
          ),
      },
      {
        path: "register-specialties",
        name: "RegisterSpecialty",
        component: () =>
          import(
            /* webpackChunkName: "professional" */ "@/views/Professional/pages/RegisterSpecialty"
          ),
      },
      {
        path: ":id/edit-specialty",
        name: "EditSpecialty",
        component: () =>
          import(
            /* webpackChunkName: "professional" */ "@/views/Professional/pages/RegisterSpecialty"
          ),
      },
      {
        path: "list-target-audience",
        name: "ListTargetAudience",
        component: () =>
          import(
            /* webpackChunkName: "professional" */ "@/views/Professional/pages/ListTargetAudience"
          ),
      },
      {
        path: "register-target-audience",
        name: "RegisterTargetAudience",
        component: () =>
          import(
            /* webpackChunkName: "professional" */ "@/views/Professional/pages/RegisterTargetAudience"
          ),
      },
      {
        path: ":id/edit-target-audience",
        name: "EditTargetAudience",
        component: () =>
          import(
            /* webpackChunkName: "professional" */ "@/views/Professional/pages/RegisterTargetAudience"
          ),
      },
      {
        path: "list-days-of-the-week",
        name: "ListDaysOfTheWeek",
        component: () =>
          import(
            /* webpackChunkName: "professional" */ "@/views/Professional/pages/ListDaysOfTheWeek"
          ),
      },
      {
        path: "register-day-of-the-week",
        name: "RegisterDayOfTheWeek",
        component: () =>
          import(
            /* webpackChunkName: "professional" */ "@/views/Professional/pages/RegisterDayOfTheWeek"
          ),
      },
      {
        path: ":id/edit-day-of-the-week",
        name: "EditDayOfTheWeek",
        component: () =>
          import(
            /* webpackChunkName: "professional" */ "@/views/Professional/pages/RegisterDayOfTheWeek"
          ),
      },
      {
        path: "list-method-payment",
        name: "ListMethodPayment",
        component: () =>
          import(
            /* webpackChunkName: "professional" */ "@/views/Professional/pages/ListMethodPayment"
          ),
      },
      {
        path: "register-method-payment",
        name: "RegisterMethodPayment",
        component: () =>
          import(
            /* webpackChunkName: "professional" */ "@/views/Professional/pages/RegisterMethodPayment"
          ),
      },
      {
        path: ":id/edit-method-payment",
        name: "EditMethodPayment",
        component: () =>
          import(
            /* webpackChunkName: "professional" */ "@/views/Professional/pages/RegisterMethodPayment"
          ),
      },
      {
        path: "list-status-schedule",
        name: "ListStatusSchedule",
        component: () =>
          import(
            /* webpackChunkName: "professional" */ "@/views/Professional/pages/ListStatusSchedule"
          ),
      },
      {
        path: "register-status-schedule",
        name: "RegisterStatusSchedule",
        component: () =>
          import(
            /* webpackChunkName: "professional" */ "@/views/Professional/pages/RegisterStatusSchedule"
          ),
      },
      {
        path: ":id/edit-status-schedule",
        name: "EditStatusSchedule",
        component: () =>
          import(
            /* webpackChunkName: "professional" */ "@/views/Professional/pages/RegisterStatusSchedule"
          ),
      },
      {
        path: "validate-professionals",
        name: "ValidateProfessionals",
        component: () =>
          import(
            /* webpackChunkName: "professional" */ "@/views/Professional/pages/ValidateProfessionals"
          ),
      },
      {
        path: ":id/details",
        name: "ValidateProfessionalsDetails",
        component: () =>
          import(
            /* webpackChunkName: "professional" */ "@/views/Professional/pages/ValidateProfessionals/Details"
          ),
      },
      {
        path: "list-schedules",
        name: "ListSchedules",
        component: () =>
          import(
            /* webpackChunkName: "professional" */ "@/views/Professional/pages/ListSchedules"
          ),
      },
      {
        path: ":id/schedule/:idSchedule/details",
        name: "ScheduleDetails",
        component: () =>
          import(
            /* webpackChunkName: "professional" */ "@/views/Professional/pages/ListSchedules/Details"
          ),
      },
    ],
  },
];
